// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp1.1',
        date: '2026-08-03',
        title: 'Sitio público con identidad del Pacífico',
        notes: [
            { type: 'feature',     text: 'Portada pública: ticker, hero con la señal en vivo, carruseles de noticias y videos, páginas de sección y de artículo' },
            { type: 'feature',     text: 'Superficies en vivo (/vivo, /vivo/<slug>) y video bajo demanda (/watch/<slug>)' },
            { type: 'feature',     text: 'Estética raizal: madera de marimba, marigold y ladrillo del cartel del festival; titulares en Fraunces y motivo de teclado de marimba en los encabezados' },
            { type: 'feature',     text: 'Navegación por control remoto (D-pad) heredada del core, útil en pantalla de TV' },
            { type: 'improvement', text: 'Nav con acceso directo a EN VIVO, que antes no existía; la portada prioriza CULTURA' },
            { type: 'improvement', text: 'SEO propio (Open Graph, datos estructurados, sitemap) y robots que indexa el sitio pero bloquea /admin y /login' },
        ],
    },
    {
        version: 'dp1.0',
        date: '2026-08-03',
        title: 'CMS inicial',
        notes: [
            { type: 'feature', text: 'Panel administrativo derivado del core de TeleDeportes: canales en vivo, catálogo VOD, categorías, noticias y estudio web' },
            { type: 'feature', text: 'Autenticación, permisos por dominio y guardas de ruta (preset TSS)' },
        ],
    },
];

export default CHANGELOG;
